<div class="d-flex justify-content-center center px-2">

  <app-text-field
    class="w-100"
    [type]="'default'"
    (input)="data.channel"
    label="{{'name_channel'| translate}}"
    [(ngModel)]="data.channel"
    (keydown.enter)="save()"
  ></app-text-field>

</div>

<mat-divider></mat-divider>

<div class="bg-light d-flex justify-content-sm-around" mat-dialog-actions>

  <app-button class="btn-cancel"
    (onChangeClick)="onNoClick()"
    [btnType]="'no-border'">
    <span class="cancel-color">
      {{'cancel' | translate}}
    </span>
  </app-button>

  <app-button class="btn-submit ms-2"
   (onChangeClick)="save()">
    {{ 'save' | translate }}
  </app-button>

</div>
